import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import './DeltaWifiLocation.scss';

const DeltaWifiLocation = ({ city, $rootScope }) => {
  const isDesktop = $rootScope.matchMedia.md;

  if (city && city?.name) {
    return (
      <div
        className={cx('DeltaWifiLocation', {
          'DeltaWifiLocation--sm': !isDesktop,
        })}
      >
        <div className="DeltaWifiLocation__cityName--text">{city?.name}</div>
      </div>
    );
  }
  return null;
};

DeltaWifiLocation.propTypes = {
  city: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  $rootScope: PropTypes.shape({
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      ipadLandscape: PropTypes.bool,
      xl: PropTypes.bool,
    }).isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  city: state.amexDeltaWifi?.city,
});

DeltaWifiLocation.displayName = 'DeltaWifiLocation';
export { DeltaWifiLocation as ComponentDeltaWifiLocationUnderTest };
export default connect(mapStateToProps)(DeltaWifiLocation);
